<template>
    <div class="sub-item-2">
        <div style="text-align: center; padding-bottom: 10px">
            <img src="/image/resource/telegram_phone2-01.png" width="400px"/>
        </div>
        <div style="text-align: center; margin-bottom: 70px">
            <div ><h1 style="font-weight: 800; width: 97%; color: white; text-shadow: 2px 2px grey;">Únete a mi grupo gratuito<br> de Telegram</h1>
                <!--<h3>y descarga mi recetario saludable</h3>-->
                <a href="https://t.me/cambiandotusalud" style="width: 90%" target="_blank" ><div class="button-telegram">ÚNETE AQUÍ</div></a></div>
            <br><div ><h2 style="font-weight: 800; width: 97%; color: white; text-shadow: 2px 2px grey;">O ESCRIBENOS VÍA</h2></div>
            <a href="https://m.me/cambiasalud" style="width: 90%" target="_blank" ><div class="button-whatsapp">Messenger</div></a></div>
        </div>


</template>
<script>
    import {mapState} from 'vuex'
    import axios from 'axios'
    export default {
        name: 'section_buton_telegram',
        components: {

        },
        created(){

        },
        data(){
            return {

            }
        },
        computed: {
            ...mapState,


        },
        methods:{

        }

    }
</script>
<style>
    .btnx{
        height: 50px;
        font-size: 1.5rem;
        font-weight: 700;
        width: 50%;
        margin-left: 10%
    }
    .button-telegram{
         padding: 15px;
         background-color: #5E72E4;
         color: white;
         font-weight: 700;
         border-radius: 5px;
         cursor: pointer;
         font-size: 2rem;
     }
    .button-whatsapp{
        padding: 15px;
        background-color: white;
        color: #63B4FF;
        font-weight: 700;
        border-radius: 5px;
        cursor: pointer;
        font-size: 2rem;
    }
</style>